export const getLocalizedPath = (path: string, lang: string) => {
  if (lang === 'EN') return path;
  const prefix = lang === 'JP' ? '/ja' : '/id';
  return `${prefix}${path === '/' ? '' : path}`;
};
